import React from "react";
import Jobs from "../components/Jobs/Jobs";
export default function JobsPage() {
  return (
    <div className="page-layout">
      <Jobs />
    </div>
  );
}
